module.exports = __webpack_public_path__ + "img/slide1.c7901722.jpg";